import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

/**
 * Data source for Admin → Clients → Pay+Tip Requests: every team that has
 * pressed Request Access, newest first. The orderBy doubles as the
 * existence filter — Firestore returns only docs carrying
 * payTipRequestedAt, so no separate where() is needed.
 *
 * Shape (house convention): [loading, teams, error].
 */
export function usePayTipRequests() {
    const [state, setState] = useState({ loading: true, teams: [], error: null });

    useEffect(() => firebase.firestore()
        .collection('teams')
        .orderBy('payTipRequestedAt', 'desc')
        .limit(200)
        .onSnapshot(
            (snap) => setState({
                loading: false,
                teams: snap.docs.map((doc) => ({ teamId: doc.id, ...doc.data() })),
                error: null,
            }),
            (err) => {
                console.warn('[usePayTipRequests] listen failed:', err && err.message);
                setState({ loading: false, teams: [], error: err.message || 'Could not load requests' });
            },
        ), []);

    return [state.loading, state.teams, state.error];
}

export default usePayTipRequests;
